/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControl } from 'material-ui/Form';
import Input, {
    InputLabel,
} from 'material-ui/Input';
import appSettings from '../../../../config/appSettings';
import CurrenyFormat from '../../../common/CurrenyFormat';

const styles = ({ spacing: { unit } }) => ({
    root: {
        padding: unit * 2,
    },
    formControl: {
        marginTop: unit * 3,
        minWidth: unit * 26,
        '&:not(:last-of-type)': {
            marginRight: unit * 3,
        },
    },
});

function ApplicantsIncome(props) {
    const applicantsArr = Array.from(Array(props.applicants || 0).keys());
    const inputs = applicantsArr.map(item => (
        <FormControl
            className={props.classes.formControl}
            key={item}
        >
            <InputLabel htmlFor={`income-${item}`}>
                {(
                    applicantsArr.length > 1
                        ? `Applicant ${item + 1} Taxable Income`
                        : 'Applicant Taxable Income'
                )}
            </InputLabel>
            <Input
                id={`income-${item}`}
                value={props.applicantsIncome[item].amount}
                onChange={event => props.setApplicantsIncome(item, event)}
                inputComponent={CurrenyFormat}
            />
        </FormControl>
    ));
    return (!appSettings.onlyOneApplicant && props.applicants && props.mortgageType)
        ? (
            <div className={props.classes.root}>
                {inputs}
            </div>
        )
        : '';
}

ApplicantsIncome.propTypes = {
    classes: PropTypes.object.isRequired,
    applicants: PropTypes.number.isRequired,
    mortgageType: PropTypes.string.isRequired,
    applicantsIncome: PropTypes.array.isRequired,
    setApplicantsIncome: PropTypes.func.isRequired,
};

export default withStyles(styles)(ApplicantsIncome);



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/components/ApplicantsIncome.js